import type { IExtendedRouteObject } from "./types";

import { dashboardRoutes } from "@routes/dashboard/route";
import { usersRoutes } from "@routes/userManagement/users/route";
import { adminsRoutes } from "@routes/userManagement/admins/route";
import { assistantsRoutes } from "@routes/userManagement/assistants/route";
import { studentsRoutes } from "@routes/userManagement/students/route";
import { teachersRoutes } from "@routes/userManagement/teachers/route";
import { courseManagementRoutes } from "@routes/courseManagement/route";
import { trainingCourseManagementRoutes } from "@routes/trainingCourseManagement/route";
import { trainingCourseAssistantManagementRoutes } from "@routes/trainingCourseAssistantManagement/route";
import { codeManagementRoutes } from "@routes/codeManagement/route";
import { contentManagementRoutes } from "@routes/contentManagement/route";
import { onlineExamManagementRoutes } from "@routes/onlineExamManagement/route";
import { descriptiveExamManagementRoutes } from "@routes/descriptiveExamManagement/route";
import { channelManagementRoutes } from "@routes/channelManagement/route";
import { commentManagementRoutes } from "@routes/commentManagement/route";
import { passwordRoutes } from "@routes/userManagement/password/route";
import { teacherRankRoutes } from "@routes/teacherRank/route";
import { binaryQuestionsRoutes } from "@routes/binaryQuestions/route";
import { multipleChoiceQuestionsRoutes } from "@routes/multipleChoiceQuestions/route";
import { notificationManagementRoutes } from "@routes/notification/route";
import { messagesManagementRoutes } from "@routes/messages/route";
import { teacherListRoutes } from "@routes/student/teacherList/route";
import { myTrainingCourseListRoutes } from "@routes/student/myTrainingCourseList/route";
import { trainingCourseListRoutes } from "@routes/student/trainingCourseList/route";
import { myChannelListRoutes } from "@routes/student/myChannelList/route";
import { studentNotificationsRoutes } from "@routes/student/notification/route";
import { studentMessagesRoutes } from "@routes/student/messages/route";
import { profileRoutes } from "@routes/student/profile/route";
import { studentSettingsRoutes } from "@routes/student/settings/route";
import { popularCoursesRoutes } from "@routes/pupularCourses/route";
import { settingsRoutes } from "@routes/settings/route";
import { chatManagementRoutes } from "@routes/chat/route";
import { supportRoutes } from "@routes/support/route";
import { myStudentsCoursesRoutes } from "@routes/myStudentsCourses/route";
import { myExamsRoutes } from "@routes/student/myExams/route";
import { myTeachersRoutes } from "@routes/myTeachers/route";
import { contactManagementRoutes } from "@routes/contactManagement/route";
import { blogPostRoutes } from "@routes/blogPost/route";

export const routes: IExtendedRouteObject[] = [
  ...dashboardRoutes,
  ...usersRoutes,
  ...adminsRoutes,
  ...assistantsRoutes,
  ...studentsRoutes,
  ...teachersRoutes,
  ...courseManagementRoutes,
  ...trainingCourseManagementRoutes,
  ...trainingCourseAssistantManagementRoutes,
  ...codeManagementRoutes,
  ...contentManagementRoutes,
  ...onlineExamManagementRoutes,
  ...descriptiveExamManagementRoutes,
  ...channelManagementRoutes,
  ...commentManagementRoutes,
  ...teachersRoutes,
  ...passwordRoutes,
  ...teacherRankRoutes,
  ...binaryQuestionsRoutes,
  ...multipleChoiceQuestionsRoutes,
  ...notificationManagementRoutes,
  ...messagesManagementRoutes,
  ...teacherListRoutes,
  ...trainingCourseListRoutes,
  ...myTrainingCourseListRoutes,
  ...myChannelListRoutes,
  ...studentNotificationsRoutes,
  ...studentMessagesRoutes,
  ...profileRoutes,
  ...studentSettingsRoutes,
  ...popularCoursesRoutes,
  ...settingsRoutes,
  ...chatManagementRoutes,
  ...supportRoutes,
  ...myStudentsCoursesRoutes,
  ...myExamsRoutes,
  ...myTeachersRoutes,
  ...contactManagementRoutes,
  ...blogPostRoutes,
];
